<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (テキストのみ) 表示
    </div>
    <TextModal
      v-if="showableModal"
      :title-text="'タイトルが入ります'"
      :caption-text="
        'キャプションエリアです。\n詳細事項を手短に書いてください。'
      "
      :primary-button-text="'プライマリボタン'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import TextModal from '../../components/molecules/modals/text-modal'

export default {
  components: { TextModal },
  data() {
    return {
      showableModal: false
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    }
  }
}
</script>
